import { FullBookType, emptyBookObject } from "types/books"
import React from "react"

interface BookContextType {
	book: FullBookType
}

export const BookContext = React.createContext<BookContextType>({
	book: emptyBookObject
})